import { Link } from "react-router-dom";
import { Mail, MapPin, Phone } from "lucide-react";

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="mt-24 border-t border-[#D9CFC2]/60 bg-white"
    >
      <div className="container-luxe py-16">
        <div className="grid gap-12 md:grid-cols-4">
          <div className="md:col-span-2">
            <div className="flex items-baseline gap-2">
              <span className="font-[Cormorant_Garamond] text-2xl font-semibold text-[#1A1D1A]">
                Sagita Rasmadi
              </span>
              <span className="text-[10px] uppercase tracking-[0.3em] text-[#C6A66B]">
                LLC
              </span>
            </div>
            <p className="mt-4 max-w-md text-sm leading-relaxed text-[#4A524C]">
              A boutique property-management &amp; hospitality consultancy —
              managing premium serviced apartments across the UK on behalf of
              private owners, family offices and investors.
            </p>
            <div className="mt-6 h-px w-12 bg-[#C6A66B]/60" />
            <div className="mt-6 space-y-2 text-sm text-[#4A524C]">
              <a
                href="mailto:info@sagita-llc.com"
                data-testid="footer-email-link"
                className="inline-flex items-center gap-2 transition-colors hover:text-[#7A8C7B]"
              >
                <Mail size={14} className="text-[#C6A66B]" />
                info@sagita-llc.com
              </a>
              <a
                href="tel:+18668037635"
                data-testid="footer-phone-link"
                className="flex items-center gap-2 transition-colors hover:text-[#7A8C7B]"
              >
                <Phone size={14} className="text-[#C6A66B]" />
                +1 866 803 7635
              </a>
              <div className="flex items-start gap-2 pt-1" data-testid="footer-registered-office">
                <MapPin size={14} className="mt-0.5 flex-shrink-0 text-[#C6A66B]" />
                <div>
                  <div className="text-[10px] font-medium uppercase tracking-[0.2em] text-[#967A45]">
                    Registered Office
                  </div>
                  <div className="mt-1 leading-relaxed">
                    30 N Gould St Ste R<br />
                    Sheridan, WY 82801, USA
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div>
            <h4 className="overline mb-5">Navigate</h4>
            <ul className="space-y-3 text-sm">
              {[
                { to: "/", l: "Home" },
                { to: "/services", l: "Services" },
                { to: "/portfolio", l: "Portfolio" },
                { to: "/about", l: "About" },
                { to: "/contact", l: "Contact" },
              ].map((it) => (
                <li key={it.to}>
                  <Link
                    to={it.to}
                    data-testid={`footer-link-${it.l.toLowerCase().replace(/\s+/g, "-")}`}
                    className="text-[#4A524C] transition-colors hover:text-[#7A8C7B]"
                  >
                    {it.l}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="overline mb-5">Hospitality</h4>
            <ul className="space-y-3 text-sm text-[#4A524C]">
              <li>Owner consultations</li>
              <li>Portfolio repositioning</li>
              <li>Managed operations</li>
              <li>Press &amp; partnerships</li>
            </ul>
          </div>
        </div>

        <div className="mt-14 flex flex-col items-start justify-between gap-4 border-t border-[#D9CFC2]/60 pt-8 text-xs text-[#4A524C] md:flex-row md:items-center">
          <span data-testid="footer-copyright">
            © {new Date().getFullYear()} Sagita Rasmadi LLC. All Rights Reserved.
          </span>
          <span className="tracking-[0.18em] text-[#C6A66B]">
            CRAFTED FOR DISCERNING TRAVELLERS
          </span>
        </div>
      </div>
    </footer>
  );
}
